export default {
  areas: {
    hero: {
      eyebrow: 'Einsatzgebiet',
      title: 'Sicherheitskameras & Alarmanlagen im gesamten Rhein-Main-Gebiet',
      subtitle: 'Von Frankfurt über Offenbach, Hanau und Darmstadt bis Groß-Gerau: SSG Signaltechnik plant, installiert und betreut Videoüberwachung und Alarmanlagen für Privat und Gewerbe – persönlich und vor Ort.',
      ctaPrimary: 'Kostenlose Erstberatung anfragen',
      ctaSecondary: 'Videoüberwachung entdecken',
    },
    breadcrumbHome: 'Startseite',
    breadcrumbCurrent: 'Einsatzgebiet',
    intro: {
      eyebrow: 'Wo wir für Sie im Einsatz sind',
      title: 'Kurze Wege im ganzen Ballungsraum',
      p1: 'Unser Fachbetrieb für Sicherheitstechnik sitzt in Hainburg – und ist von dort aus schnell im gesamten Rhein-Main-Gebiet unterwegs. Egal ob Sicherheitskamera, Videoüberwachung oder Alarmanlage: Wir kommen zu Ihnen, analysieren Ihr Objekt vor Ort und montieren alles sauber und fachgerecht.',
      p2: 'Ob Privathaus, Mehrfamilienhaus, Ladenlokal, Büro, Lager oder Werkstatt – wir betreuen Projekte aller Größenordnungen in Frankfurt, Offenbach, Hanau, Darmstadt, Groß-Gerau und allen umliegenden Städten und Gemeinden.',
    },
    city: 'Stadt',
    district: 'Landkreis',
    coverage: {
      eyebrow: 'Lokal verwurzelt',
      title: 'Ihr Fachbetrieb aus der Region – für die Region',
      p1: 'Als lokaler Fachbetrieb für Sicherheitstechnik im Rhein-Main-Gebiet kennen wir die Anforderungen und Gegebenheiten vor Ort. Für Ihre Sicherheitskamera oder Alarmanlage heißt das: kurze Anfahrtswege, persönliche Ansprechpartner und schnelle Termine – ob Beratung, Montage oder Wartung.',
      p2: 'Auch über das Rhein-Main-Gebiet hinaus sind wir nach Absprache unterwegs. Sprechen Sie uns einfach an – wir prüfen gerne, was für Ihr Projekt möglich ist.',
      ctaPrimary: 'Jetzt anfragen',
      ctaSecondary: 'Alarmanlagen entdecken',
      caption: 'Persönliche Montage und Einrichtung vor Ort – von Hainburg aus im ganzen Rhein-Main-Gebiet.',
    },
    cta: {
      title: 'Sicherheitskamera oder Alarmanlage für Ihr Objekt?',
      lead: 'Wir beraten Sie unverbindlich und zeigen Ihnen, welche Lösung zu Ihrem Objekt und Budget passt – im gesamten Rhein-Main-Gebiet und Umgebung.',
      primary: 'Kostenlose Erstberatung anfragen',
      secondary: 'KameraPlaner starten',
    },
  },
};